import React, { Component } from 'react';

class Footer extends Component {
  
  render() {
    const footer = (
    <footer className="text-center">
    <p>© 2017 Jay Hall</p>
    <div className="contact">
        <ul className="list-inline intro-social-buttons">
            <li>
                <a href="https://twitter.com/devjayhall" className="btn btn-sm"><i className="fa fa-twitter fa-fw"></i> <span className="network-name">@devjayhall</span></a>
            </li>
            <li>
                <a href="https://github.com/Jahjahcity" className="btn btn-sm"><i className="fa fa-github fa-fw"></i> <span className="network-name">Jahjahcity</span></a>
            </li>
            <li>
                <a href="https://www.jayhall.net" className="btn btn-sm"><i className="fa fa-suitcase fa-fw"></i> <span className="network-name">Website</span></a>
            </li>
        </ul>
    </div>
    </footer>
    );
    return (
         footer
    );
  }
  
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js